import { Outlet } from 'react-router-dom';
import { NavBar } from './NavBar';

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-yellow-50">
      <NavBar />
      {/* pb-20 on mobile to clear the fixed bottom nav (h-16 + gap) */}
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 py-6 pb-24 sm:pb-6">
        <Outlet />
      </main>
    </div>
  );
}
